$(function () {

    'use strict';

    RivalIQ.apps.Site.start({
        rivalIqSettings: window.rivalIqSettings
    });

});
